const POPPER_INJECTION_KEY = Symbol("popper");
const POPPER_CONTENT_INJECTION_KEY = Symbol("popperContent");
export { POPPER_CONTENT_INJECTION_KEY, POPPER_INJECTION_KEY };